import classNames from 'classnames';
import { observer } from 'mobx-react';
import React from 'react';
import { useI18n } from '@udemy/i18n';
import { Button } from '@udemy/react-core-components';
import { LabIcon } from '../card-components/lab-icon.react-component';
import { sendLabsResumeBannerContinueClickEvent, sendLabsResumeBannerDismissClickEvent, sendReviewLabsBannerDismissedEvent } from './events';
import styles from "./labs-learning-banner.module.css";
import { LabsLearningDismissModal } from './labs-learning-dismiss-modal.react-component';
const SingleLabsLearningBannerComponent = function (props) {
  var _store$firstRunningLa;
  const {
    gettext,
    interpolate
  } = useI18n();
  const {
    store
  } = props;
  async function onDismiss() {
    await store.setDismissed();
    sendReviewLabsBannerDismissedEvent(false);
    store.showDismissModal();
    sendLabsResumeBannerDismissClickEvent(store.firstRunningLab);
  }
  async function onContinue() {
    sendLabsResumeBannerContinueClickEvent(store.firstRunningLab);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, !store.isDismissed && /*#__PURE__*/React.createElement("section", {
    "aria-labelledby": "labs-learning-banner",
    "data-testid": "labs-learning-banner"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['container']
  }, /*#__PURE__*/React.createElement(LabIcon, null), /*#__PURE__*/React.createElement("div", {
    className: styles['text-container']
  }, /*#__PURE__*/React.createElement("div", {
    className: "ud-heading-md"
  }, /*#__PURE__*/React.createElement("h2", {
    id: "labs-learning-banner"
  }, gettext('There’s still time for you to continue your lab from where you left off.'))), /*#__PURE__*/React.createElement("div", {
    className: "ud-text-md"
  }, interpolate(gettext('%(labTitle)s is still in-progress.'), {
    labTitle: (_store$firstRunningLa = store.firstRunningLab) === null || _store$firstRunningLa === void 0 ? void 0 : _store$firstRunningLa.lab.title
  }, true))), /*#__PURE__*/React.createElement("div", {
    className: styles['action-buttons']
  }, /*#__PURE__*/React.createElement(Button, {
    "data-purpose": "lab-banner-dismiss",
    onClick: onDismiss,
    size: "medium",
    udStyle: "ghost",
    className: classNames('ud-link-neutral', styles['button'])
  }, gettext('Dismiss')), /*#__PURE__*/React.createElement(Button, {
    "data-purpose": "lab-banner-continue",
    onClick: onContinue,
    udStyle: "primary",
    size: "medium",
    componentClass: "a",
    href: store.continueLabPageUrl
  }, gettext('Continue lab'))))), /*#__PURE__*/React.createElement(LabsLearningDismissModal, {
    isOpen: store.isDismissModalActive,
    labsLearningBannerStore: store
  }));
};
SingleLabsLearningBannerComponent.displayName = 'SingleLabsLearningBanner';
export const SingleLabsLearningBanner = observer(SingleLabsLearningBannerComponent);
//# sourceMappingURL=single-labs-learning-banner.react-component.js.map